Ext.define('SA.ExportController', {
    constructor({toolbarButton, contentType}) {
        this.toolbarButton = toolbarButton;
        this.observable = new Ext.util.Observable();
        this.widget = Ext.widget({xtype: 'inert-export-widget', contentType});
        this.menu = Ext.widget({xtype: 'inert-arrow-export-menu', target: this.toolbarButton, items: [this.widget]});

        this.initEvents();
    },

    initEvents() {
        this.menu.on('hide', this.destroy, this);
        this.toolbarButton.on('click', this.destroy, this);
        this.widget.on('click:export', this.onClickExport, this);
        this.widget.on('click:cancel', this.destroy, this);
        SA.Viewport.on('resize', this.refreshPosition, this);
    },

    destroy() {
        if (this.destroyed) {
            return;
        }

        this.destroyed = true;
        this.menu.destroy();
        this.toolbarButton.setInactive();
        this.toolbarButton.un('click', this.destroy, this);
        SA.Viewport.un('resize', this.refreshPosition, this);
    },

    enableForm() {
        this.widget.enable();
    },

    isDestroyed() {
        return this.destroyed;
    },

    on() {
        this.observable.on(...arguments);
    },

    onClickExport(formState) {
        this.observable.fireEvent('click:export', formState);
        this.destroy();
    },

    refreshPosition() {
        this.menu.syncPosition();
    },

    removeLoadMask() {
        this.widget.removeLoadMask();
    }
});